import { config } from "../config";
import React from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

const LogoutButton: React.FC = () => {
  const navigate = useNavigate();
  const onClick = async () => {
    try { 
      await api("/api/logout", { method: "POST" }); 
    } catch {} 
    
    // Clear all storage
    try { 
      localStorage.clear(); 
      sessionStorage.clear(); 
    } catch {}
    
    // Clear Cloudflare Access cookie
    document.cookie = "CF_Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.nthecloud.com; SameSite=None; Secure";
    
    // Redirect to Cloudflare Access logout endpoint to properly clear authentication
    window.location.href = "https://digitalatlaslabs.cloudflareaccess.com/cdn-cgi/access/logout";
  };
  
  return (
    <button onClick={onClick} className="px-3 py-1.5 rounded bg-red-600 text-white hover:bg-red-700">
      Logout
    </button>
  );
};
export default LogoutButton;
